import { jsx, jsxs } from 'react/jsx-runtime';
import authStatusConstants from '../../../constants/authStatusConstants.js';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import { containerStyle, fieldsetStyle, radioLabel } from '../styles.js';
var StubbedAuthSelector = function StubbedAuthSelector(_ref) {
  var stubbedAuthStatus = _ref.stubbedAuthStatus,
    stubbedStatus = _ref.stubbedStatus,
    _onChange = _ref.onChange;
  return stubbedStatus === paymentStatus.CREATED && jsx("div", {
    style: containerStyle,
    children: jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed 3DS options:"
      }), Object.values(authStatusConstants).map(function (status) {
        return jsxs("label", {
          style: radioLabel,
          children: [jsx("input", {
            type: "radio",
            name: "stubbedAuth",
            value: status,
            checked: stubbedAuthStatus === status,
            onChange: function onChange() {
              return _onChange(status);
            }
          }), status]
        }, status);
      })]
    })
  });
};
export { StubbedAuthSelector as default };